<template>

    <div class="flex flex-col ac-icon-div">
            <img :src="require(`../../assets/images/${icon}`)" alt="icon" width="64px" class="ac-icon-div__image">
            <h6 class="ac-icon-div__title"> {{title}}</h6>
            <p class="ac-icon-div__text"> {{text}} </p>
    </div>

</template>

<script>
  export default{
      name: 'AcIconDiv',

      props: ['icon', 'title', 'text']
  }
</script>

<style scoped lang="scss">

@import "../../styles/core/variables.scss";



.ac-icon-div{
    &__image{
        width: 6.4rem;
        margin-bottom: 1.6rem;
    }

    &__title{
        font-size: 2.4rem;
        line-height: 120%;
        font-weight: 700;
        color: white;
        margin-bottom: 1.6rem;
        font-family: $secondary-font;
    }

    &__text{
        color: white;
        font-family: $secondary-font;
        font-weight: 400;
        font-size: 1.6rem;
        line-height: 150%;
    }
}

@media screen and (max-width: $mobile-small){

    .ac-icon-div{

        align-items: center;
        padding: 0 3.2rem;
        text-align: center;

        &:not(:last-child){
           margin-bottom: 5.6rem;
         
        }


        &__image{
        width: 6.4rem;
        margin: 0 auto;
        margin-bottom: 1.6rem;
    }
    }
}

</style>